export default __webpack_public_path__ + "static/media/close.cfccae79.svg";